import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M31 18a4 4 0 014 4v20a4 4 0 01-4 4 2 2 0 11-4 0h-8a2 2 0 11-4 0 4 4 0 01-4-4V22a4 4 0 014-4h16zm-2 4a2 2 0 00-2 2v8a2 2 0 104 0v-8a2 2 0 00-2-2zm2-20a4 4 0 014 4v6a4 4 0 01-4 4H15a4 4 0 01-4-4V6a4 4 0 014-4h16z",
  fill: "#262626"
}));

var SvgAddOnFridgeXLarge = function SvgAddOnFridgeXLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgAddOnFridgeXLarge;